import $http from "@/api/index";
import { getToken } from "../helpers/auth";
/**
 * 获取我的流程信息列表
 * @param {*} pagination 分页参数
 * @param {*} queryJson 查询条件
 * @param {*} categoryId 任务类型（0.服务台1.我的流程2.待办任务3.已办任务）
 */
export function GetTaskList(pagination, queryJson, categoryId) {
  let getUrl = {
    method: "GET",
    url: `/WfMyTask/GetTaskList?pagination=${pagination}&queryJson=${queryJson}&categoryId=${categoryId}&user=${JSON.stringify(
      getToken()
    )}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 获取审批节点
 * @param {*} taskId 主键ID
 */
export function GetTastInfo(taskId) {
  let getUrl = {
    method: "GET",
    url: `/WfMyTask/GetEntity?taskId=${taskId}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 获取当前节点信息
 * @param {*} processId
 */
export function GetList(processId) {
  let getUrl = {
    method: "GET",
    url: `/WfMyTask/GetList?processId=${processId}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 获取当前任务节点主键
 * @param {*} processId
 */
export function GetCurrentNodeIds(processId) {
  let getUrl = {
    method: "GET",
    url: `/WfMyTask/GetCurrentNodeIds?processId=${processId}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 获取审批浏览记录
 * @param {*} processId	流程实例ID
 */
export function GetHistory(processId) {
  let getUrl = {
    method: "GET",
    url: `/WfMyTask/GetHistory?processId=${processId}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}
